import React from 'react';

interface Props {
  phone: string;
  onCall?: (phone: string) => void;
}

export default function ClickToCall({ phone, onCall }: Props) {
  if (!phone) return null;

  const handleClick = () => {
    if (onCall) {
      onCall(phone);
    } else {
      // Dispatch global event for WebRTCPhone to handle
      window.dispatchEvent(new CustomEvent('crm:call', { detail: { phone } }));
    }
  };

  return (
    <button
      onClick={handleClick}
      title={`Позвонить ${phone}`}
      style={{
        background: 'none', border: 'none',
        cursor: 'pointer', padding: '2px 4px',
        borderRadius: 6, color: '#16a34a',
        fontSize: 16, lineHeight: 1,
        transition: 'background 0.15s',
      }}
      onMouseEnter={e => (e.currentTarget.style.background = 'rgba(22,163,74,0.1)')}
      onMouseLeave={e => (e.currentTarget.style.background = 'none')}
    >
      📞
    </button>
  );
}
